import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import environment from '../../Environment';
import {
  DeclineEstimateMutation,
  DeclineEstimateMutation$variables,
  EstimateDeclineReason,
} from './__generated__/DeclineEstimateMutation.graphql';

const mutation = graphql`
  mutation DeclineEstimateMutation($input: DeclineEstimateInput!) {
    declineEstimate(input: $input) {
      estimate {
        id
        status
      }
    }
  }
`;

const commit = (
  webToken,
  reason: EstimateDeclineReason,
  note: string | null | undefined,
  callback
) => {
  const variables: DeclineEstimateMutation$variables = {
    input: {
      webToken: webToken,
      reason: reason,
      note: note,
    },
  };

  commitMutation<DeclineEstimateMutation>(environment, {
    mutation,
    variables,
    onCompleted: (response) => {
      const estimate = response.declineEstimate?.estimate;
      callback(estimate);
    },
    onError: (err) => console.error(err),
  });
};

export default commit;
